<template>
  <div :id="id" class="row">
    <div class="col-12">
      <div class="row align-items-center">
        <LmTextInput
        :id="`label-${id}`"
        ref="inputFocus"
        class="col-12 col-md-6"
        v-model="component.componentProps.label"
        @input="$emit('input', component)"
        label="Label"
        placeholder="Label"
        />
        <LmTextInput
        :id="`nombre-${id}`"
        class="col-12 col-md-6"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        label="Nombre"
        placeholder="placeholder"
        />
        <LmSelect
          :id="id + 'css'"
          class="col-12 col-md-6"
          v-model="component.class"
          :options="{
            content: [
              {value: 'col-12 col-md-3',text: '25%'},
              {value: 'col-12 col-md-6', text: '50%'},
              {value: 'col-12 col-md-9', text: '75%'},
              {value: 'col-12 col-md-12', text: '100%'}
            ]
          }"
          label="Ancho vista escritorio"
          :help="$t('help_width_form_element')"
          @input="$emit('input', component)"
        />
        <div class="col-12 col-md-6 pr-2">
          <b-form-checkbox
          :id="id + 'multiple'"
          name="multiple"
          v-model="component.componentProps.multiple"
          @input="$emit('input', component)"
          >
          Multiple
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <div class="col-12">
      <h5>Opciones</h5>
        <LmSelect
          :id="id + 'children-of'"
          v-model="component.childrenOf"
          :options="optionsChildOf"
          label="Depende de"
          :help="$t('help_rely_on_form_element')"
          @input="$emit('input', component)"
        />
        <LmSuperPowerSelectV2
          :options="options"
          label="Origenes de datos"
          v-model="component.componentProps.urlPathFromGetOptions"
          @input="setUrlPathFromGetOptions($event)"
        />
        <template v-if="!isManualOptionLoadDisabled">
          <div
            v-for="(option, index) in component.componentProps.options"
            :key="index"
            class="row align-items-center"
            >
            <LmTextInput
              :disabled="isManualOptionLoadDisabled"
              class="col-12 col-md-5"
              v-model="component.componentProps.options[index].id"
              @input="$emit('input', component)"
              label="Id"
              placeholder="Id"
            />
            <LmTextInput
              :disabled="isManualOptionLoadDisabled"
              class="col-12 col-md-5"
              v-model="component.componentProps.options[index].name"
              @input="$emit('input', component)"
              label="Name"
              placeholder="Name"
            />
            <font-awesome-icon
              v-if="isAtLeastOneOption"
              class="mt-3 col-12 col-md-1"
              :class="{clickable: !isManualOptionLoadDisabled, 'not-allowed': isManualOptionLoadDisabled}"
              icon="trash"
              @click="!isManualOptionLoadDisabled && removeOption(index)" />
          </div>
          <LmButton
            :disabled="isManualOptionLoadDisabled"
            type="button"
            value="Agregar opción"
            @click.native="addOption"
          />
        </template>
    </div>
    <div class="col-12">
      <LmSuperPowerSelectV2
        :disabled="!!component.childrenOf"
        :options="component.componentProps.options"
        :urlPathFromGetOptions="component.componentProps.urlPathFromGetOptions"
        label="Valor por defecto"
        v-model="component.componentProps.defaultValue"
        @input="$emit('input', component)"
      />
    </div>
    <div class="col-12">
      <h5>Validation</h5>
      <div class="row align-items-center">
        <div class="custom-control custom-checkbox col-12 col-md mt-1">
          <b-form-checkbox
            :name="component.formObjectToSendToServerProperty"
            v-model="validations.required"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
            >
            required
          </b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false
      }
    }
  },
  props: {
    optionsChildOf: {
      type: Object,
      default: () => ({ content: [] })
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  components: {
    LmButton,
    LmSuperPowerSelectV2
  },
  computed: {
    isManualOptionLoadDisabled () {
      return !!this.component.componentProps.urlPathFromGetOptions || !!this.component.childrenOf
    },
    isAtLeastOneOption () {
      return this.component.componentProps.options.length > 1
    }
  },
  methods: {
    setUrlPathFromGetOptions (event) {
      this.component.componentProps.urlPathFromGetOptions = event?.name
    },
    addOption () {
      this.component.componentProps.options.push({ value: '', text: '' })
    },
    removeOption (optionIndex) {
      this.component.componentProps.options.splice(optionIndex, 1)
    }
  },
  watch: {
    'component.childrenOf' () {
      this.component.componentProps.disabled = !!this.component.childrenOf || false
    }
  }
}
</script>
